import React from 'react';
import { arrayOf, number, object, shape, string } from 'prop-types';
import { URI } from '@fiverr-private/futile';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { buildSubCategoryNameKey, buildNestedSubCategoryNameKey } from '../../utils/translation/categories';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const MoreServices = (props, context) => {

    const { otherNestedSubCategoryGigs, sellerName } = props;
    const { general, currencyConverter } = context;
    const { subCategoryId } = general;

    if (!otherNestedSubCategoryGigs || !otherNestedSubCategoryGigs.length) {
        return null;
    }

    return (
        <div className="more-services">
            <header>
                <h2 className="more-services-title">
                    <I18n k={'gig_page_perseus.more_services.title'}
                        params={{ sub_category_name: translate(buildSubCategoryNameKey(subCategoryId)) || '' }}/>
                </h2>
            </header>
            <ul>
                {
                    otherNestedSubCategoryGigs.map(({ serviceSubcategoryId, serviceNestedSubcategoryId, serviceSlug, startPrice }, index) => {
                        const url = new URI(`/${sellerName}/${serviceSlug}`).addParams({ from_service_type_box: 'true' }).toString();
                        const translatedService = serviceNestedSubcategoryId ?
                            translate(buildNestedSubCategoryNameKey(serviceSubcategoryId, serviceNestedSubcategoryId)):
                            translate(buildSubCategoryNameKey(subCategoryId));

                        return (
                            <li key={index} className="box-shadow-z1">
                                <a href={url}>
                                    <p>{translatedService}</p>
                                    <I18n k={'gig_page_perseus.more_services.starting_at'}/> {currencyConverter.convert(startPrice)}
                                </a>
                            </li>
                        );

                    })
                }
            </ul>
        </div>
    );
};

MoreServices.propTypes = {
    otherNestedSubCategoryGigs: arrayOf(
        shape({
            serviceSubcategoryId: number,
            serviceNestedSubcategoryId: number,
            serviceSlug: string,
            startPrice: number
        })
    ),
    sellerName: string
};

MoreServices.contextTypes = {
    general: object,
    currencyConverter: object
};

export { MoreServices };
export default SafePureComponent(MoreServices);
